import styled from 'styled-components'

export const Location = styled.span`
  display: flex;
  align-items: center;
  font-weight: 500;
  font-size: ${props => (props.isHorizontal ? '12px' : '10px')};
  font-style: normal;
  color: #696977;
  &:before {
    content: '';
    background-image: url('https://www.webmotors.com.br/assets/img/icon/icon-location.svg');
    background-repeat: no-repeat;
    background-position: center;
    background-size: 100%;
    width: 15px;
    height: 15px;
    margin-right: 4px;
    display: inline-block;
  }
`
